export default "__VITE_ASSET__CJk9gY_h__"